import { inject } from '@angular/core';
import { ComponentName } from '../../api/service-providers/models/models/component-name';
import { TenantsFacadeService } from '../../store/tenants/tenants.facade.service';

export type TenantPackagesInclude = ReturnType<typeof injectTenantPackagesInclude>;

export const injectTenantPackagesInclude = () => {
  const tenantsFacadeService = inject(TenantsFacadeService);
  return (tenantPackageFeatureComponent: ComponentName): boolean => {
    const tenant = tenantsFacadeService.activeTenant;
    return tenant?.packagesFeaturesComponents.includes(tenantPackageFeatureComponent) ?? false;
  };
};
